import React, { useState } from "react";
import "../styles/contactPage.css";
import ContactTeam from "../images/contact/ContactTeam.jpg";
import email from "../images/contact/emailIcon.png";
import phone from "../images/contact/phoneIcon.png";
import house from "../images/contact/houseIcon.png";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");
  const [verified, setVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Loader state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    if (!verified) {
      setStatus("Please complete the ReCAPTCHA.");
      return;
    }

    setIsLoading(true);

    try {
      await axios.post("https://healthcareinteraction.com/send-email", {
        to: "ian.johnson@healthcareinteraction.com",
        message: `
          Name: ${formData.name}
          Email: ${formData.email}
          Message: ${formData.message}
        `,
      });

      setFormData({ name: "", email: "", message: "" });
      alert("Email sent successfully!");
    } catch (error) {
      console.error("Error sending email:", error);
      setStatus("Failed to send email. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <h1 className="contactTitle">Get In Touch</h1>
      <section className="contactUsContainer">
        <div className="contactUsLeftColumn">
          <h2>Contact Us</h2>
          <form className="contactUsForm" onSubmit={handleSubmit}>
            <h3>Send a message</h3>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <ReCAPTCHA
              sitekey="6LfwtwwrAAAAAOsaEbujjlsWJNocEFbiH7sHK3iR" // Replace with your site key
              onChange={() => setVerified(true)}
            />
            <button type="submit" disabled={!verified || isLoading}>
              {isLoading ? (
                <>
                  <span className="spinner"></span> Sending...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </form>
          {status && <p className="statusMessage">{status}</p>}
        </div>
        <div className="contactUsRightColumn">
          <img
            className="ContactTeamImg"
            src={ContactTeam}
            alt="Healthcare Interactive Team"
          />
        </div>
      </section>

      <section className="contactHowWeCanHelp">
        <div className="contactFindUsWrap">
          <div className="contactFindUsColumn1">
            <h3>Visit Us</h3>
            <div className="contactFindUsContent1">
              <img src={house} alt="House Icon" />
              <p>Healthcare interAction</p>
              <p>3 Gransden Park, Potton Road</p>
              <p>Abbotsley, Cambridgeshire,</p>
              <p>PE19 6TY (UK)</p>
            </div>
          </div>
          <div className="contactFindUsColumn2">
            <h3>Call Us</h3>
            <div className="contactFindUsContent2">
              <img src={phone} alt="Phone Icon" />
              <p>+44 (0)1767 676900</p>
            </div>
          </div>
          <div className="contactFindUsColumn3">
            <h3>Email Us</h3>
            <div className="contactFindUsContent3">
              <img src={email} alt="Email Icon" />
              <p>info@healthcareinteraction.com</p>
            </div>
          </div>
        </div>
      </section>

      <section className="howToFindUs">
        <div className="howToFindUsLeftColumn">
          <h2>How To Find Us</h2>
          <p>Healthcare interAction</p>
          <p>3 Gransden Park, Potton Road</p>
          <p>Abbotsley, Cambridgeshire,</p>
          <p>PE19 6TY (UK)</p>
        </div>
        <div className="howToFindUsRightColumn">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5816.7489114644295!2d-0.17158093048989786!3d52.19538608396714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4877da9ee681f2ab%3A0xfc70589d8f78ba00!2sHealthcare%20interAction!5e0!3m2!1sen!2suk!4v1727367628974!5m2!1sen!2suk"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="How To Find Us Map"
          ></iframe>
        </div>
      </section>
    </>
  );
}

export default Contact;
